import { ArrowLeft, ChevronDown, Users } from 'lucide-react';
import AddPerson from '../dialogs/AddPerson';
import { redirectToContact } from '../shared/customUiSdk';
import Dialogs from '../shared/Dialogs';
import Translate from '../shared/Translate';
import { formatDateTime, formatPhoneNumber, getTextColorClassName } from '../shared/Utils';
import '../styles/sms.css';

const SmsDetail = (props) => {
  const displaySmsParty = (number, name) => {
    const personInfo = props.fullScreenNotification.pipedriveData?.persons?.find(person => person.phoneNumber === number);
    return (
      <div className="commlog-party-info">
        <div className="commlog-party-name">
          {
            personInfo
              ? <span onClick={() => redirectToContact(props.sdk, personInfo.personId)}>
                {personInfo.personName}
              </span>
              : (name
                ? <>
                  <div className='commlog-party-title'>{name}</div>
                  <div className="source-label">{Translate.get('common.fromOptimCall.label')}</div>
                  <button
                    className="add-button"
                    onClick={() => Dialogs.open(
                      <AddPerson credentials={props.credentials} sdk={props.sdk} phoneNumber={number} providedName={name} />
                    )}
                  >
                    {Translate.get('common.add.button')}
                  </button>
                </>
                : <>
                  <div className='commlog-party-title'>{Translate.get('common.unknown.label')}</div>
                  <button
                    className="add-button"
                    onClick={() => Dialogs.open(
                      <AddPerson credentials={props.credentials} sdk={props.sdk} phoneNumber={number} />
                    )}
                  >
                    {Translate.get('common.add.button')}
                  </button>
                </>
              )
          }
        </div>
        <div className="commlog-party-number">{formatPhoneNumber(number)}</div>
      </div>
    )
  }

  const smsType = (smsState) => {
    switch (smsState) {
      case 'received':
        return Translate.get('sms.type.inbound');
      default:
        return Translate.get('sms.type.outbound');
    }
  }

  // const cookies = getCookies();
  // const [callFrom, setCallFrom] = useState(cookies.callFrom || '');
  // const [callAs, setCallAs] = useState('Selected by OptimCall');
  // const [callTo, setCallTo] = useState(
  //   props.sms.state === 'received'
  //     ? props.sms.sender
  //     : props.sms.recipient
  // );
  // const [recipients, setRecipients] = useState(
  //   props.sms.state === 'received'
  //     ? props.sms.recipient
  //     : props.sms.sender
  // );
  // const [message, setMessage] = useState('');
  // const [smsGateway, setSmsGateway] = useState(cookies.smsGateway || '');
  // const [expandedSections, setExpandedSections] = useState({
  //   placeCall: false,
  //   sendSms: false,
  // });

  // const toggleSection = (section) => {
  //   setExpandedSections({
  //     ...expandedSections,
  //     [section]: !expandedSections[section],
  //   });
  // };

  return (
    <div className="sms-detail-container">
      <div className="sms-detail-content">
        <div className="flex flex-col">
          <div className="header">
            <div className="header-left">
              <div className="back-icon-container">
                <ArrowLeft
                  size={24}
                  onClick={() => {
                    props.container.tell({
                      _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$CloseFullScreenNotification',
                    });
                  }}
                />
              </div>
              <div className="sms-info">
                <div className="sms-title">{smsType(props.sms.state)}</div>
                <div className="sms-time">{formatDateTime(props.sms.time, props.serverTimeOffset)}</div>
              </div>
            </div>
          </div>


          <div className="flex flex-row justify-between">
            <div className="sms-detail-main">
              <div className="sms-detail-parties">
                {displaySmsParty(props.sms.sender)}
                <div className="dropdown-arrow"><ChevronDown size={24} /></div>
                {displaySmsParty(props.sms.recipient)}
              </div>
            </div>
            <div>
              <div className="stats-container">
                <div className={'stats-state ' + getTextColorClassName(props.fullScreenNotification)}>
                  {Translate.get('sms.state.' + (props.sms.state || 'unknown'))}
                </div>
                <div className="avatar">
                  <div className={'avatar-icon ' + getTextColorClassName(props.fullScreenNotification)}>
                    <Users size={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sms-message-box">
            <strong>{Translate.get('sms.detail.message')}:</strong> {props.sms.message}
          </div>
        </div>
      </div>

      {/* <PlaceCall
        callFrom={callFrom}
        setCallFrom={setCallFrom}
        callAs={callAs}
        setCallAs={setCallAs}
        callTo={callTo}
        setCallTo={setCallTo}
        expanded={expandedSections.placeCall}
        toggleSection={() => toggleSection('placeCall')}
        settings={props.settings}
        providedNumber={props.providedNumber}
        stateData={props.stateData}
        credentials={props.credentials}
        cardView
      />

      {cookies.smsGateway &&
        <SendSms
          recipients={recipients}
          setRecipients={setRecipients}
          message={message}
          setMessage={setMessage}
          smsGateway={smsGateway}
          setSmsGateway={setSmsGateway}
          expanded={expandedSections.sendSms}
          toggleSection={() => toggleSection('sendSms')}
          settings={props.settings}
          providedNumber={props.providedNumber}
          stateData={props.stateData}
          credentials={props.credentials}
          cardView
        />
      } */}

    </div>
  );
};

export default SmsDetail;